module.exports = {
	"emoji": {
		":grinning:": 128512,
		":grimacing:": 128556,
		":grin:": 128513,
		":joy:": 128514,
		":smiley:": 128515,
		":smile:": 128516,
		":sweat_smile:": 128517,
		":laughing:": 128518,
		":innocent:": 128519,
		":wink:": 128521,
		":blush:": 128522,
		":slight_smile:": 128578,
		":upside_down:": 128579,
		":relaxed:": 9786,
		":yum:": 128523,
		":relieved:": 128524,
		":heart_eyes:": 128525,
		":kissing_heart:": 128536,
		":kissing:": 128535,
		":kissing_smiling_eyes:": 128537,
		":kissing_closed_eyes:": 128538,
		":stuck_out_tongue_winking_eye:": 128540,
		":stuck_out_tongue_closed_eyes:": 128541,
		":stuck_out_tongue:": 128539,
		":money_mouth:": 129297,
		":nerd:": 129299,
		":sunglasses:": 128526,
		":hugging:": 129303,
		":smirk:": 128527,
		":no_mouth:": 128566,
		":neutral_face:": 128528,
		":expressionless:": 128529,
		":unamused:": 128530,
		":rolling_eyes:": 128580,
		":thinking:": 129300,
		":flushed:": 128563,
		":disappointed:": 128542,
		":worried:": 128543,
		":angry:": 128544,
		":rage:": 128545,
		":pensive:": 128532,
		":confused:": 128533,
		":slight_frown:": 128577,
		":frowning2:": 9785,
		":persevere:": 128547,
		":confounded:": 128534,
		":tired_face:": 128555,
		":weary:": 128553,
		":triumph:": 128548,
		":open_mouth:": 128558,
		":scream:": 128561,
		":fearful:": 128552,
		":cold_sweat:": 128560,
		":hushed:": 128559,
		":frowning:": 128550,
		":anguished:": 128551,
		":cry:": 128546,
		":disappointed_relieved:": 128549,
		":sleepy:": 128554,
		":sweat:": 128531,
		":sob:": 128557,
		":dizzy_face:": 128565,
		":astonished:": 128562,
		":zipper_mouth:": 129296,
		":mask:": 128567,
		":thermometer_face:": 129298,
		":head_bandage:": 129301,
		":sleeping:": 128564,
		":zzz:": 128164,
		":poop:": 128169,
		":smiling_imp:": 128520,
		":imp:": 128127,
		":japanese_ogre:": 128121,
		":japanese_goblin:": 128122,
		":skull:": 128128,
		":ghost:": 128123,
		":alien:": 128125,
		":robot:": 129302,
		":smiley_cat:": 128570,
		":smile_cat:": 128568,
		":joy_cat:": 128569,
		":heart_eyes_cat:": 128571,
		":smirk_cat:": 128572,
		":kissing_cat:": 128573,
		":scream_cat:": 128576,
		":crying_cat_face:": 128575,
		":pouting_cat:": 128574,
		":raised_hands:": 128588,
		":clap:": 128079,
		":wave:": 128075,
		":thumbsup:": 128077,
		":thumbsdown:": 128078,
		":punch:": 128074,
		":fist:": 9994,
		":v:": 9996,
		":ok_hand:": 128076,
		":raised_hand:": 9995,
		":open_hands:": 128080,
		":muscle:": 128170,
		":pray:": 128591,
		":point_up:": 9757,
		":point_up_2:": 128070,
		":point_down:": 128071,
		":point_left:": 128072,
		":point_right:": 128073,
		":middle_finger:": 128405,
		":hand_splayed:": 128400,
		":metal:": 129304,
		":vulcan:": 128406,
		":writing_hand:": 9997,
		":nail_care:": 128133,
		":lips:": 128068,
		":tongue:": 128069,
		":ear:": 128066,
		":nose:": 128067,
		":eye:": 128065,
		":eyes:": 128064,
		":bust_in_silhouette:": 128100,
		":busts_in_silhouette:": 128101,
		":speaking_head:": 128483,
		":baby:": 128118,
		":boy:": 128102,
		":girl:": 128103,
		":man:": 128104,
		":woman:": 128105,
		":person_with_blond_hair:": 128113,
		":older_man:": 128116,
		":older_woman:": 128117,
		":man_with_gua_pi_mao:": 128114,
		":man_with_turban:": 128115,
		":cop:": 128110,
		":construction_worker:": 128119,
		":guardsman:": 128130,
		":spy:": 128373,
		":santa:": 127877,
		":angel:": 128124,
		":princess:": 128120,
		":bride_with_veil:": 128112,
		":walking:": 128694,
		":runner:": 127939,
		":dancer:": 128131,
		":dancers:": 128111,
		":couple:": 128107,
		":two_men_holding_hands:": 128108,
		":two_women_holding_hands:": 128109,
		":bow:": 128583,
		":information_desk_person:": 128129,
		":no_good:": 128581,
		":ok_woman:": 128582,
		":raising_hand:": 128587,
		":person_with_pouting_face:": 128590,
		":person_frowning:": 128589,
		":haircut:": 128135,
		":massage:": 128134,
		":couple_with_heart:": 128145,
		":couple_ww:": 128105,
		":couple_mm:": 128104,
		":couplekiss:": 128143,
		":kiss_ww:": 128105,
		":kiss_mm:": 128104,
		":family:": 128106,
		":family_mwg:": 128104,
		":family_mwgb:": 128104,
		":family_mwbb:": 128104,
		":family_mwgg:": 128104,
		":family_wwb:": 128105,
		":family_wwg:": 128105,
		":family_wwgb:": 128105,
		":family_wwbb:": 128105,
		":family_wwgg:": 128105,
		":family_mmb:": 128104,
		":family_mmg:": 128104,
		":family_mmgb:": 128104,
		":family_mmbb:": 128104,
		":family_mmgg:": 128104,
		":womans_clothes:": 128090,
		":shirt:": 128085,
		":jeans:": 128086,
		":necktie:": 128084,
		":dress:": 128087,
		":bikini:": 128089,
		":kimono:": 128088,
		":lipstick:": 128132,
		":kiss:": 128139,
		":footprints:": 128099,
		":high_heel:": 128096,
		":sandal:": 128097,
		":boot:": 128098,
		":mans_shoe:": 128094,
		":athletic_shoe:": 128095,
		":womans_hat:": 128082,
		":tophat:": 127913,
		":helmet_with_cross:": 9937,
		":mortar_board:": 127891,
		":crown:": 128081,
		":school_satchel:": 127890,
		":pouch:": 128093,
		":purse:": 128091,
		":handbag:": 128092,
		":briefcase:": 128188,
		":eyeglasses:": 128083,
		":dark_sunglasses:": 128374,
		":ring:": 128141,
		":closed_umbrella:": 127746,
		":dog:": 128054,
		":cat:": 128049,
		":mouse:": 128045,
		":hamster:": 128057,
		":rabbit:": 128048,
		":bear:": 128059,
		":panda_face:": 128060,
		":koala:": 128040,
		":tiger:": 128047,
		":lion_face:": 129409,
		":cow:": 128046,
		":pig:": 128055,
		":pig_nose:": 128061,
		":frog:": 128056,
		":octopus:": 128025,
		":monkey_face:": 128053,
		":see_no_evil:": 128584,
		":hear_no_evil:": 128585,
		":speak_no_evil:": 128586,
		":monkey:": 128018,
		":chicken:": 128020,
		":penguin:": 128039,
		":bird:": 128038,
		":baby_chick:": 128036,
		":hatching_chick:": 128035,
		":hatched_chick:": 128037,
		":wolf:": 128058,
		":boar:": 128023,
		":horse:": 128052,
		":unicorn:": 129412,
		":bee:": 128029,
		":bug:": 128027,
		":snail:": 128012,
		":beetle:": 128030,
		":ant:": 128028,
		":spider:": 128375,
		":scorpion:": 129410,
		":crab:": 129408,
		":snake:": 128013,
		":turtle:": 128034,
		":tropical_fish:": 128032,
		":fish:": 128031,
		":blowfish:": 128033,
		":dolphin:": 128044,
		":whale:": 128051,
		":whale2:": 128011,
		":crocodile:": 128010,
		":leopard:": 128006,
		":tiger2:": 128005,
		":water_buffalo:": 128003,
		":ox:": 128002,
		":cow2:": 128004,
		":dromedary_camel:": 128042,
		":camel:": 128043,
		":elephant:": 128024,
		":goat:": 128016,
		":ram:": 128015,
		":sheep:": 128017,
		":racehorse:": 128014,
		":pig2:": 128022,
		":rat:": 128000,
		":mouse2:": 128001,
		":rooster:": 128019,
		":turkey:": 129411,
		":dove:": 128330,
		":dog2:": 128021,
		":poodle:": 128041,
		":cat2:": 128008,
		":rabbit2:": 128007,
		":chipmunk:": 128063,
		":feet:": 128062,
		":dragon:": 128009,
		":dragon_face:": 128050,
		":cactus:": 127797,
		":christmas_tree:": 127876,
		":evergreen_tree:": 127794,
		":deciduous_tree:": 127795,
		":palm_tree:": 127796,
		":seedling:": 127793,
		":herb:": 127807,
		":shamrock:": 9752,
		":four_leaf_clover:": 127808,
		":bamboo:": 127885,
		":tanabata_tree:": 127883,
		":leaves:": 127811,
		":fallen_leaf:": 127810,
		":maple_leaf:": 127809,
		":ear_of_rice:": 127806,
		":hibiscus:": 127802,
		":sunflower:": 127803,
		":rose:": 127801,
		":tulip:": 127799,
		":blossom:": 127804,
		":cherry_blossom:": 127800,
		":bouquet:": 128144,
		":mushroom:": 127812,
		":chestnut:": 127792,
		":jack_o_lantern:": 127875,
		":shell:": 128026,
		":spider_web:": 128376,
		":earth_americas:": 127758,
		":earth_africa:": 127757,
		":earth_asia:": 127759,
		":full_moon:": 127765,
		":waning_gibbous_moon:": 127766,
		":last_quarter_moon:": 127767,
		":waning_crescent_moon:": 127768,
		":new_moon:": 127761,
		":waxing_crescent_moon:": 127762,
		":first_quarter_moon:": 127763,
		":waxing_gibbous_moon:": 127764,
		":new_moon_with_face:": 127770,
		":full_moon_with_face:": 127773,
		":first_quarter_moon_with_face:": 127771,
		":last_quarter_moon_with_face:": 127772,
		":sun_with_face:": 127774,
		":crescent_moon:": 127769,
		":star:": 11088,
		":star2:": 127775,
		":dizzy:": 128171,
		":sparkles:": 10024,
		":comet:": 9732,
		":sunny:": 9728,
		":white_sun_small_cloud:": 127780,
		":partly_sunny:": 9925,
		":white_sun_cloud:": 127781,
		":white_sun_rain_cloud:": 127782,
		":cloud:": 9729,
		":cloud_rain:": 127783,
		":thunder_cloud_rain:": 9928,
		":cloud_lightning:": 127785,
		":zap:": 9889,
		":fire:": 128293,
		":boom:": 128165,
		":snowflake:": 10052,
		":cloud_snow:": 127784,
		":snowman2:": 9731,
		":snowman:": 9924,
		":wind_blowing_face:": 127788,
		":dash:": 128168,
		":cloud_tornado:": 127786,
		":fog:": 127787,
		":umbrella2:": 9730,
		":umbrella:": 9748,
		":droplet:": 128167,
		":sweat_drops:": 128166,
		":ocean:": 127754,
		":green_apple:": 127823,
		":apple:": 127822,
		":pear:": 127824,
		":tangerine:": 127818,
		":lemon:": 127819,
		":banana:": 127820,
		":watermelon:": 127817,
		":grapes:": 127815,
		":strawberry:": 127827,
		":melon:": 127816,
		":cherries:": 127826,
		":peach:": 127825,
		":pineapple:": 127821,
		":tomato:": 127813,
		":eggplant:": 127814,
		":hot_pepper:": 127798,
		":corn:": 127805,
		":sweet_potato:": 127840,
		":honey_pot:": 127855,
		":bread:": 127838,
		":cheese:": 129472,
		":poultry_leg:": 127831,
		":meat_on_bone:": 127830,
		":fried_shrimp:": 127844,
		":egg:": 127859,
		":hamburger:": 127828,
		":fries:": 127839,
		":hotdog:": 127789,
		":pizza:": 127829,
		":spaghetti:": 127837,
		":taco:": 127790,
		":burrito:": 127791,
		":ramen:": 127836,
		":stew:": 127858,
		":fish_cake:": 127845,
		":sushi:": 127843,
		":bento:": 127857,
		":curry:": 127835,
		":rice_ball:": 127833,
		":rice:": 127834,
		":rice_cracker:": 127832,
		":oden:": 127842,
		":dango:": 127841,
		":shaved_ice:": 127847,
		":ice_cream:": 127848,
		":icecream:": 127846,
		":cake:": 127856,
		":birthday:": 127874,
		":custard:": 127854,
		":candy:": 127852,
		":lollipop:": 127853,
		":chocolate_bar:": 127851,
		":popcorn:": 127871,
		":doughnut:": 127849,
		":cookie:": 127850,
		":beer:": 127866,
		":beers:": 127867,
		":wine_glass:": 127863,
		":cocktail:": 127864,
		":tropical_drink:": 127865,
		":champagne:": 127870,
		":sake:": 127862,
		":tea:": 127861,
		":coffee:": 9749,
		":baby_bottle:": 127868,
		":fork_and_knife:": 127860,
		":fork_knife_plate:": 127869,
		":soccer:": 9917,
		":basketball:": 127936,
		":football:": 127944,
		":baseball:": 9918,
		":tennis:": 127934,
		":volleyball:": 127952,
		":rugby_football:": 127945,
		":8ball:": 127921,
		":golf:": 9971,
		":golfer:": 127948,
		":ping_pong:": 127955,
		":badminton:": 127992,
		":hockey:": 127954,
		":field_hockey:": 127953,
		":cricket:": 127951,
		":ski:": 127935,
		":skier:": 9975,
		":snowboarder:": 127938,
		":ice_skate:": 9976,
		":bow_and_arrow:": 127993,
		":fishing_pole_and_fish:": 127907,
		":rowboat:": 128675,
		":swimmer:": 127946,
		":surfer:": 127940,
		":bath:": 128704,
		":basketball_player:": 9977,
		":lifter:": 127947,
		":bicyclist:": 128692,
		":mountain_bicyclist:": 128693,
		":horse_racing:": 127943,
		":levitate:": 128372,
		":trophy:": 127942,
		":running_shirt_with_sash:": 127933,
		":medal:": 127941,
		":military_medal:": 127894,
		":reminder_ribbon:": 127895,
		":rosette:": 127989,
		":ticket:": 127915,
		":tickets:": 127903,
		":performing_arts:": 127917,
		":art:": 127912,
		":circus_tent:": 127914,
		":microphone:": 127908,
		":headphones:": 127911,
		":musical_score:": 127932,
		":musical_keyboard:": 127929,
		":saxophone:": 127927,
		":trumpet:": 127930,
		":guitar:": 127928,
		":violin:": 127931,
		":clapper:": 127916,
		":video_game:": 127918,
		":space_invader:": 128126,
		":dart:": 127919,
		":game_die:": 127922,
		":slot_machine:": 127920,
		":bowling:": 127923,
		":red_car:": 128663,
		":taxi:": 128661,
		":blue_car:": 128665,
		":bus:": 128652,
		":trolleybus:": 128654,
		":race_car:": 127950,
		":police_car:": 128659,
		":ambulance:": 128657,
		":fire_engine:": 128658,
		":minibus:": 128656,
		":truck:": 128666,
		":articulated_lorry:": 128667,
		":tractor:": 128668,
		":motorcycle:": 127949,
		":bike:": 128690,
		":rotating_light:": 128680,
		":oncoming_police_car:": 128660,
		":oncoming_bus:": 128653,
		":oncoming_automobile:": 128664,
		":oncoming_taxi:": 128662,
		":aerial_tramway:": 128673,
		":mountain_cableway:": 128672,
		":suspension_railway:": 128671,
		":railway_car:": 128643,
		":train:": 128651,
		":monorail:": 128669,
		":bullettrain_side:": 128644,
		":bullettrain_front:": 128645,
		":light_rail:": 128648,
		":mountain_railway:": 128670,
		":steam_locomotive:": 128642,
		":train2:": 128646,
		":metro:": 128647,
		":tram:": 128650,
		":station:": 128649,
		":helicopter:": 128641,
		":airplane_small:": 128745,
		":airplane:": 9992,
		":airplane_departure:": 128747,
		":airplane_arriving:": 128748,
		":sailboat:": 9973,
		":motorboat:": 128741,
		":speedboat:": 128676,
		":ferry:": 9972,
		":cruise_ship:": 128755,
		":rocket:": 128640,
		":satellite_orbital:": 128752,
		":seat:": 128186,
		":anchor:": 9875,
		":construction:": 128679,
		":fuelpump:": 9981,
		":busstop:": 128655,
		":vertical_traffic_light:": 128678,
		":traffic_light:": 128677,
		":checkered_flag:": 127937,
		":ship:": 128674,
		":ferris_wheel:": 127905,
		":roller_coaster:": 127906,
		":carousel_horse:": 127904,
		":construction_site:": 127959,
		":foggy:": 127745,
		":tokyo_tower:": 128508,
		":factory:": 127981,
		":fountain:": 9970,
		":rice_scene:": 127889,
		":mountain:": 9968,
		":mountain_snow:": 127956,
		":mount_fuji:": 128507,
		":volcano:": 127755,
		":japan:": 128510,
		":camping:": 127957,
		":tent:": 9978,
		":park:": 127966,
		":motorway:": 128739,
		":railway_track:": 128740,
		":sunrise:": 127749,
		":sunrise_over_mountains:": 127748,
		":desert:": 127964,
		":beach:": 127958,
		":island:": 127965,
		":city_sunset:": 127751,
		":city_dusk:": 127750,
		":cityscape:": 127961,
		":night_with_stars:": 127747,
		":bridge_at_night:": 127753,
		":milky_way:": 127756,
		":stars:": 127776,
		":sparkler:": 127879,
		":fireworks:": 127878,
		":rainbow:": 127752,
		":homes:": 127960,
		":european_castle:": 127984,
		":japanese_castle:": 127983,
		":stadium:": 127967,
		":statue_of_liberty:": 128509,
		":house:": 127968,
		":house_with_garden:": 127969,
		":house_abandoned:": 127962,
		":office:": 127970,
		":department_store:": 127980,
		":post_office:": 127971,
		":european_post_office:": 127972,
		":hospital:": 127973,
		":bank:": 127974,
		":hotel:": 127976,
		":convenience_store:": 127978,
		":school:": 127979,
		":love_hotel:": 127977,
		":wedding:": 128146,
		":classical_building:": 127963,
		":church:": 9962,
		":mosque:": 128332,
		":synagogue:": 128333,
		":kaaba:": 128331,
		":shinto_shrine:": 9961,
		":watch:": 8986,
		":iphone:": 128241,
		":calling:": 128242,
		":computer:": 128187,
		":keyboard:": 9000,
		":desktop:": 128421,
		":printer:": 128424,
		":mouse_three_button:": 128433,
		":trackball:": 128434,
		":joystick:": 128377,
		":compression:": 128476,
		":minidisc:": 128189,
		":floppy_disk:": 128190,
		":cd:": 128191,
		":dvd:": 128192,
		":vhs:": 128252,
		":camera:": 128247,
		":camera_with_flash:": 128248,
		":video_camera:": 128249,
		":movie_camera:": 127909,
		":projector:": 128253,
		":film_frames:": 127902,
		":telephone_receiver:": 128222,
		":telephone:": 9742,
		":pager:": 128223,
		":fax:": 128224,
		":tv:": 128250,
		":radio:": 128251,
		":microphone2:": 127897,
		":level_slider:": 127898,
		":control_knobs:": 127899,
		":stopwatch:": 9201,
		":timer:": 9202,
		":alarm_clock:": 9200,
		":clock:": 128368,
		":hourglass_flowing_sand:": 9203,
		":hourglass:": 8987,
		":satellite:": 128225,
		":battery:": 128267,
		":electric_plug:": 128268,
		":bulb:": 128161,
		":flashlight:": 128294,
		":candle:": 128367,
		":wastebasket:": 128465,
		":oil:": 128738,
		":money_with_wings:": 128184,
		":dollar:": 128181,
		":yen:": 128180,
		":euro:": 128182,
		":pound:": 128183,
		":moneybag:": 128176,
		":credit_card:": 128179,
		":gem:": 128142,
		":scales:": 9878,
		":wrench:": 128295,
		":hammer:": 128296,
		":hammer_pick:": 9874,
		":tools:": 128736,
		":pick:": 9935,
		":nut_and_bolt:": 128297,
		":gear:": 9881,
		":chains:": 9939,
		":gun:": 128299,
		":bomb:": 128163,
		":knife:": 128298,
		":dagger:": 128481,
		":crossed_swords:": 9876,
		":shield:": 128737,
		":smoking:": 128684,
		":skull_crossbones:": 9760,
		":coffin:": 9904,
		":urn:": 9905,
		":amphora:": 127994,
		":crystal_ball:": 128302,
		":prayer_beads:": 128255,
		":barber:": 128136,
		":alembic:": 9879,
		":telescope:": 128301,
		":microscope:": 128300,
		":hole:": 128371,
		":pill:": 128138,
		":syringe:": 128137,
		":thermometer:": 127777,
		":label:": 127991,
		":bookmark:": 128278,
		":toilet:": 128701,
		":shower:": 128703,
		":bathtub:": 128705,
		":key:": 128273,
		":key2:": 128477,
		":couch:": 128715,
		":sleeping_accommodation:": 128716,
		":bed:": 128719,
		":door:": 128682,
		":bellhop:": 128718,
		":frame_photo:": 128444,
		":map:": 128506,
		":beach_umbrella:": 9969,
		":moyai:": 128511,
		":shopping_bags:": 128717,
		":balloon:": 127880,
		":flags:": 127887,
		":ribbon:": 127872,
		":gift:": 127873,
		":confetti_ball:": 127882,
		":tada:": 127881,
		":dolls:": 127886,
		":wind_chime:": 127888,
		":crossed_flags:": 127884,
		":izakaya_lantern:": 127982,
		":envelope:": 9993,
		":envelope_with_arrow:": 128233,
		":incoming_envelope:": 128232,
		":e-mail:": 128231,
		":love_letter:": 128140,
		":postbox:": 128238,
		":mailbox_closed:": 128234,
		":mailbox:": 128235,
		":mailbox_with_mail:": 128236,
		":mailbox_with_no_mail:": 128237,
		":package:": 128230,
		":postal_horn:": 128239,
		":inbox_tray:": 128229,
		":outbox_tray:": 128228,
		":scroll:": 128220,
		":page_with_curl:": 128195,
		":bookmark_tabs:": 128209,
		":bar_chart:": 128202,
		":chart_with_upwards_trend:": 128200,
		":chart_with_downwards_trend:": 128201,
		":page_facing_up:": 128196,
		":date:": 128197,
		":calendar:": 128198,
		":calendar_spiral:": 128467,
		":card_index:": 128199,
		":card_box:": 128451,
		":ballot_box:": 128499,
		":file_cabinet:": 128452,
		":clipboard:": 128203,
		":notepad_spiral:": 128466,
		":file_folder:": 128193,
		":open_file_folder:": 128194,
		":dividers:": 128450,
		":newspaper2:": 128478,
		":newspaper:": 128240,
		":notebook:": 128211,
		":closed_book:": 128213,
		":green_book:": 128215,
		":blue_book:": 128216,
		":orange_book:": 128217,
		":notebook_with_decorative_cover:": 128212,
		":ledger:": 128210,
		":books:": 128218,
		":book:": 128214,
		":link:": 128279,
		":paperclip:": 128206,
		":paperclips:": 128391,
		":scissors:": 9986,
		":triangular_ruler:": 128208,
		":straight_ruler:": 128207,
		":pushpin:": 128204,
		":round_pushpin:": 128205,
		":triangular_flag_on_post:": 128681,
		":flag_white:": 127987,
		":flag_black:": 127988,
		":closed_lock_with_key:": 128272,
		":lock:": 128274,
		":unlock:": 128275,
		":lock_with_ink_pen:": 128271,
		":pen_ballpoint:": 128394,
		":pen_fountain:": 128395,
		":black_nib:": 10002,
		":pencil:": 128221,
		":pencil2:": 9999,
		":crayon:": 128397,
		":paintbrush:": 128396,
		":mag:": 128269,
		":mag_right:": 128270,
		":heart:": 10084,
		":yellow_heart:": 128155,
		":green_heart:": 128154,
		":blue_heart:": 128153,
		":purple_heart:": 128156,
		":broken_heart:": 128148,
		":heart_exclamation:": 10083,
		":two_hearts:": 128149,
		":revolving_hearts:": 128158,
		":heartbeat:": 128147,
		":heartpulse:": 128151,
		":sparkling_heart:": 128150,
		":cupid:": 128152,
		":gift_heart:": 128157,
		":heart_decoration:": 128159,
		":peace:": 9774,
		":cross:": 10013,
		":star_and_crescent:": 9770,
		":om_symbol:": 128329,
		":wheel_of_dharma:": 9784,
		":star_of_david:": 10017,
		":six_pointed_star:": 128303,
		":menorah:": 128334,
		":yin_yang:": 9775,
		":orthodox_cross:": 9766,
		":place_of_worship:": 128720,
		":ophiuchus:": 9934,
		":aries:": 9800,
		":taurus:": 9801,
		":gemini:": 9802,
		":cancer:": 9803,
		":leo:": 9804,
		":virgo:": 9805,
		":libra:": 9806,
		":scorpius:": 9807,
		":sagittarius:": 9808,
		":capricorn:": 9809,
		":aquarius:": 9810,
		":pisces:": 9811,
		":id:": 127380,
		":atom:": 9883,
		":u7a7a:": 127539,
		":u5272:": 127545,
		":radioactive:": 9762,
		":biohazard:": 9763,
		":mobile_phone_off:": 128244,
		":vibration_mode:": 128243,
		":u6709:": 127542,
		":u7121:": 127514,
		":u7533:": 127544,
		":u55b6:": 127546,
		":u6708:": 127543,
		":eight_pointed_black_star:": 10036,
		":vs:": 127386,
		":accept:": 127569,
		":white_flower:": 128174,
		":ideograph_advantage:": 127568,
		":secret:": 12953,
		":congratulations:": 12951,
		":u5408:": 127540,
		":u6e80:": 127541,
		":u7981:": 127538,
		":a:": 127344,
		":b:": 127345,
		":ab:": 127374,
		":cl:": 127377,
		":o2:": 127358,
		":sos:": 127384,
		":no_entry:": 9940,
		":name_badge:": 128219,
		":no_entry_sign:": 128683,
		":x:": 10060,
		":o:": 11093,
		":anger:": 128162,
		":hotsprings:": 9832,
		":no_pedestrians:": 128695,
		":do_not_litter:": 128687,
		":no_bicycles:": 128691,
		":non-potable_water:": 128689,
		":underage:": 128286,
		":no_mobile_phones:": 128245,
		":exclamation:": 10071,
		":grey_exclamation:": 10069,
		":question:": 10067,
		":grey_question:": 10068,
		":bangbang:": 8252,
		":interrobang:": 8265,
		":100:": 128175,
		":low_brightness:": 128261,
		":high_brightness:": 128262,
		":trident:": 128305,
		":fleur-de-lis:": 9884,
		":part_alternation_mark:": 12349,
		":warning:": 9888,
		":children_crossing:": 128696,
		":beginner:": 128304,
		":recycle:": 9851,
		":u6307:": 127535,
		":chart:": 128185,
		":sparkle:": 10055,
		":eight_spoked_asterisk:": 10035,
		":negative_squared_cross_mark:": 10062,
		":white_check_mark:": 9989,
		":diamond_shape_with_a_dot_inside:": 128160,
		":cyclone:": 127744,
		":loop:": 10175,
		":globe_with_meridians:": 127760,
		":m:": 9410,
		":atm:": 127975,
		":sa:": 127490,
		":passport_control:": 128706,
		":customs:": 128707,
		":baggage_claim:": 128708,
		":left_luggage:": 128709,
		":wheelchair:": 9855,
		":no_smoking:": 128685,
		":wc:": 128702,
		":parking:": 127359,
		":potable_water:": 128688,
		":mens:": 128697,
		":womens:": 128698,
		":baby_symbol:": 128700,
		":restroom:": 128699,
		":put_litter_in_its_place:": 128686,
		":cinema:": 127910,
		":signal_strength:": 128246,
		":koko:": 127489,
		":ng:": 127382,
		":ok:": 127383,
		":up:": 127385,
		":cool:": 127378,
		":new:": 127381,
		":free:": 127379,
		":zero:": 48,
		":one:": 49,
		":two:": 50,
		":three:": 51,
		":four:": 52,
		":five:": 53,
		":six:": 54,
		":seven:": 55,
		":eight:": 56,
		":nine:": 57,
		":ten:": 128287,
		":1234:": 128290,
		":arrow_forward:": 9654,
		":pause_button:": 9208,
		":play_pause:": 9199,
		":stop_button:": 9209,
		":record_button:": 9210,
		":track_next:": 9197,
		":track_previous:": 9198,
		":fast_forward:": 9193,
		":rewind:": 9194,
		":twisted_rightwards_arrows:": 128256,
		":repeat:": 128257,
		":repeat_one:": 128258,
		":arrow_backward:": 9664,
		":arrow_up_small:": 128316,
		":arrow_down_small:": 128317,
		":arrow_double_up:": 9195,
		":arrow_double_down:": 9196,
		":arrow_right:": 10145,
		":arrow_left:": 11013,
		":arrow_up:": 11014,
		":arrow_down:": 11015,
		":arrow_upper_right:": 8599,
		":arrow_lower_right:": 8600,
		":arrow_lower_left:": 8601,
		":arrow_upper_left:": 8598,
		":arrow_up_down:": 8597,
		":left_right_arrow:": 8596,
		":arrows_counterclockwise:": 128260,
		":arrow_right_hook:": 8618,
		":leftwards_arrow_with_hook:": 8617,
		":arrow_heading_up:": 10548,
		":arrow_heading_down:": 10549,
		":hash:": 35,
		":asterisk:": 42,
		":information_source:": 8505,
		":abc:": 128292,
		":abcd:": 128289,
		":capital_abcd:": 128288,
		":symbols:": 128291,
		":musical_note:": 127925,
		":notes:": 127926,
		":wavy_dash:": 12336,
		":curly_loop:": 10160,
		":heavy_check_mark:": 10004,
		":arrows_clockwise:": 128259,
		":heavy_plus_sign:": 10133,
		":heavy_minus_sign:": 10134,
		":heavy_division_sign:": 10135,
		":heavy_multiplication_x:": 10006,
		":heavy_dollar_sign:": 128178,
		":currency_exchange:": 128177,
		":copyright:": 169,
		":registered:": 174,
		":tm:": 8482,
		":end:": 128282,
		":back:": 128281,
		":on:": 128283,
		":top:": 128285,
		":soon:": 128284,
		":ballot_box_with_check:": 9745,
		":radio_button:": 128280,
		":white_circle:": 9898,
		":black_circle:": 9899,
		":red_circle:": 128308,
		":large_blue_circle:": 128309,
		":small_orange_diamond:": 128312,
		":small_blue_diamond:": 128313,
		":large_orange_diamond:": 128310,
		":large_blue_diamond:": 128311,
		":small_red_triangle:": 128314,
		":black_small_square:": 9642,
		":white_small_square:": 9643,
		":black_large_square:": 11035,
		":white_large_square:": 11036,
		":small_red_triangle_down:": 128315,
		":black_medium_square:": 9724,
		":white_medium_square:": 9723,
		":black_medium_small_square:": 9726,
		":white_medium_small_square:": 9725,
		":black_square_button:": 128306,
		":white_square_button:": 128307,
		":speaker:": 128264,
		":sound:": 128265,
		":loud_sound:": 128266,
		":mute:": 128263,
		":mega:": 128227,
		":loudspeaker:": 128226,
		":bell:": 128276,
		":no_bell:": 128277,
		":black_joker:": 127183,
		":mahjong:": 126980,
		":spades:": 9824,
		":clubs:": 9827,
		":hearts:": 9829,
		":diamonds:": 9830,
		":flower_playing_cards:": 127924,
		":thought_balloon:": 128173,
		":anger_right:": 128495,
		":speech_balloon:": 128172,
		":clock1:": 128336,
		":clock2:": 128337,
		":clock3:": 128338,
		":clock4:": 128339,
		":clock5:": 128340,
		":clock6:": 128341,
		":clock7:": 128342,
		":clock8:": 128343,
		":clock9:": 128344,
		":clock10:": 128345,
		":clock11:": 128346,
		":clock12:": 128347,
		":clock130:": 128348,
		":clock230:": 128349,
		":clock330:": 128350,
		":clock430:": 128351,
		":clock530:": 128352,
		":clock630:": 128353,
		":clock730:": 128354,
		":clock830:": 128355,
		":clock930:": 128356,
		":clock1030:": 128357,
		":clock1130:": 128358,
		":clock1230:": 128359,
		":eye_in_speech_bubble:": 128065,
		":flag_ac:": 127462,
		":flag_af:": 127462,
		":flag_al:": 127462,
		":flag_dz:": 127465,
		":flag_ad:": 127462,
		":flag_ao:": 127462,
		":flag_ai:": 127462,
		":flag_ag:": 127462,
		":flag_ar:": 127462,
		":flag_am:": 127462,
		":flag_aw:": 127462,
		":flag_au:": 127462,
		":flag_at:": 127462,
		":flag_az:": 127462,
		":flag_bs:": 127463,
		":flag_bh:": 127463,
		":flag_bd:": 127463,
		":flag_bb:": 127463,
		":flag_by:": 127463,
		":flag_be:": 127463,
		":flag_bz:": 127463,
		":flag_bj:": 127463,
		":flag_bm:": 127463,
		":flag_bt:": 127463,
		":flag_bo:": 127463,
		":flag_ba:": 127463,
		":flag_bw:": 127463,
		":flag_br:": 127463,
		":flag_bn:": 127463,
		":flag_bg:": 127463,
		":flag_bf:": 127463,
		":flag_bi:": 127463,
		":flag_cv:": 127464,
		":flag_kh:": 127472,
		":flag_cm:": 127464,
		":flag_ca:": 127464,
		":flag_ky:": 127472,
		":flag_cf:": 127464,
		":flag_td:": 127481,
		":flag_cl:": 127464,
		":flag_cn:": 127464,
		":flag_co:": 127464,
		":flag_km:": 127472,
		":flag_cg:": 127464,
		":flag_cd:": 127464,
		":flag_cr:": 127464,
		":flag_hr:": 127469,
		":flag_cu:": 127464,
		":flag_cy:": 127464,
		":flag_cz:": 127464,
		":flag_dk:": 127465,
		":flag_dj:": 127465,
		":flag_dm:": 127465,
		":flag_do:": 127465,
		":flag_ec:": 127466,
		":flag_eg:": 127466,
		":flag_sv:": 127480,
		":flag_gq:": 127468,
		":flag_er:": 127466,
		":flag_ee:": 127466,
		":flag_et:": 127466,
		":flag_fk:": 127467,
		":flag_fo:": 127467,
		":flag_fj:": 127467,
		":flag_fi:": 127467,
		":flag_fr:": 127467,
		":flag_pf:": 127477,
		":flag_ga:": 127468,
		":flag_gm:": 127468,
		":flag_ge:": 127468,
		":flag_de:": 127465,
		":flag_gh:": 127468,
		":flag_gi:": 127468,
		":flag_gr:": 127468,
		":flag_gl:": 127468,
		":flag_gd:": 127468,
		":flag_gu:": 127468,
		":flag_gt:": 127468,
		":flag_gn:": 127468,
		":flag_gw:": 127468,
		":flag_gy:": 127468,
		":flag_ht:": 127469,
		":flag_hn:": 127469,
		":flag_hk:": 127469,
		":flag_hu:": 127469,
		":flag_is:": 127470,
		":flag_in:": 127470,
		":flag_id:": 127470,
		":flag_ir:": 127470,
		":flag_iq:": 127470,
		":flag_ie:": 127470,
		":flag_il:": 127470,
		":flag_it:": 127470,
		":flag_ci:": 127464,
		":flag_jm:": 127471,
		":flag_jp:": 127471,
		":flag_je:": 127471,
		":flag_jo:": 127471,
		":flag_kz:": 127472,
		":flag_ke:": 127472,
		":flag_ki:": 127472,
		":flag_xk:": 127485,
		":flag_kw:": 127472,
		":flag_kg:": 127472,
		":flag_la:": 127473,
		":flag_lv:": 127473,
		":flag_lb:": 127473,
		":flag_ls:": 127473,
		":flag_lr:": 127473,
		":flag_ly:": 127473,
		":flag_li:": 127473,
		":flag_lt:": 127473,
		":flag_lu:": 127473,
		":flag_mo:": 127474,
		":flag_mk:": 127474,
		":flag_mg:": 127474,
		":flag_mw:": 127474,
		":flag_my:": 127474,
		":flag_mv:": 127474,
		":flag_ml:": 127474,
		":flag_mt:": 127474,
		":flag_mh:": 127474,
		":flag_mr:": 127474,
		":flag_mu:": 127474,
		":flag_mx:": 127474,
		":flag_fm:": 127467,
		":flag_md:": 127474,
		":flag_mc:": 127474,
		":flag_mn:": 127474,
		":flag_me:": 127474,
		":flag_ms:": 127474,
		":flag_ma:": 127474,
		":flag_mz:": 127474,
		":flag_mm:": 127474,
		":flag_na:": 127475,
		":flag_nr:": 127475,
		":flag_np:": 127475,
		":flag_nl:": 127475,
		":flag_nc:": 127475,
		":flag_nz:": 127475,
		":flag_ni:": 127475,
		":flag_ne:": 127475,
		":flag_ng:": 127475,
		":flag_nu:": 127475,
		":flag_kp:": 127472,
		":flag_no:": 127475,
		":flag_om:": 127476,
		":flag_pk:": 127477,
		":flag_pw:": 127477,
		":flag_ps:": 127477,
		":flag_pa:": 127477,
		":flag_pg:": 127477,
		":flag_py:": 127477,
		":flag_pe:": 127477,
		":flag_ph:": 127477,
		":flag_pl:": 127477,
		":flag_pt:": 127477,
		":flag_pr:": 127477,
		":flag_qa:": 127478,
		":flag_ro:": 127479,
		":flag_ru:": 127479,
		":flag_rw:": 127479,
		":flag_sh:": 127480,
		":flag_kn:": 127472,
		":flag_lc:": 127473,
		":flag_vc:": 127483,
		":flag_ws:": 127484,
		":flag_sm:": 127480,
		":flag_st:": 127480,
		":flag_sa:": 127480,
		":flag_sn:": 127480,
		":flag_rs:": 127479,
		":flag_sc:": 127480,
		":flag_sl:": 127480,
		":flag_sg:": 127480,
		":flag_sk:": 127480,
		":flag_si:": 127480,
		":flag_sb:": 127480,
		":flag_so:": 127480,
		":flag_za:": 127487,
		":flag_kr:": 127472,
		":flag_es:": 127466,
		":flag_lk:": 127473,
		":flag_sd:": 127480,
		":flag_sr:": 127480,
		":flag_sz:": 127480,
		":flag_se:": 127480,
		":flag_ch:": 127464,
		":flag_sy:": 127480,
		":flag_tw:": 127481,
		":flag_tj:": 127481,
		":flag_tz:": 127481,
		":flag_th:": 127481,
		":flag_tl:": 127481,
		":flag_tg:": 127481,
		":flag_to:": 127481,
		":flag_tt:": 127481,
		":flag_tn:": 127481,
		":flag_tr:": 127481,
		":flag_tm:": 127481,
		":flag_tv:": 127481,
		":flag_ug:": 127482,
		":flag_ua:": 127482,
		":flag_ae:": 127462,
		":flag_gb:": 127468,
		":flag_us:": 127482,
		":flag_vi:": 127483,
		":flag_uy:": 127482,
		":flag_uz:": 127482,
		":flag_vu:": 127483,
		":flag_va:": 127483,
		":flag_ve:": 127483,
		":flag_vn:": 127483,
		":flag_wf:": 127484,
		":flag_eh:": 127466,
		":flag_ye:": 127486,
		":flag_zm:": 127487,
		":flag_zw:": 127487,
		":flag_re:": 127479,
		":flag_ax:": 127462,
		":flag_ta:": 127481,
		":flag_io:": 127470,
		":flag_bq:": 127463,
		":flag_cx:": 127464,
		":flag_cc:": 127464,
		":flag_gg:": 127468,
		":flag_im:": 127470,
		":flag_yt:": 127486,
		":flag_nf:": 127475,
		":flag_pn:": 127477,
		":flag_bl:": 127463,
		":flag_pm:": 127477,
		":flag_gs:": 127468,
		":flag_tk:": 127481,
		":flag_bv:": 127463,
		":flag_hm:": 127469,
		":flag_sj:": 127480,
		":flag_um:": 127482,
		":flag_ic:": 127470,
		":flag_ea:": 127466,
		":flag_cp:": 127464,
		":flag_dg:": 127465,
		":flag_as:": 127462,
		":flag_aq:": 127462,
		":flag_vg:": 127483,
		":flag_ck:": 127464,
		":flag_cw:": 127464,
		":flag_eu:": 127466,
		":flag_gf:": 127468,
		":flag_tf:": 127481,
		":flag_gp:": 127468,
		":flag_mq:": 127474,
		":flag_mp:": 127474,
		":flag_sx:": 127480,
		":flag_ss:": 127480,
		":flag_tc:": 127481,
		":flag_mf:": 127474,
		":raised_hands_tone1:": 128588,
		":raised_hands_tone2:": 128588,
		":raised_hands_tone3:": 128588,
		":raised_hands_tone4:": 128588,
		":raised_hands_tone5:": 128588,
		":clap_tone1:": 128079,
		":clap_tone2:": 128079,
		":clap_tone3:": 128079,
		":clap_tone4:": 128079,
		":clap_tone5:": 128079,
		":wave_tone1:": 128075,
		":wave_tone2:": 128075,
		":wave_tone3:": 128075,
		":wave_tone4:": 128075,
		":wave_tone5:": 128075,
		":thumbsup_tone1:": 128077,
		":thumbsup_tone2:": 128077,
		":thumbsup_tone3:": 128077,
		":thumbsup_tone4:": 128077,
		":thumbsup_tone5:": 128077,
		":thumbsdown_tone1:": 128078,
		":thumbsdown_tone2:": 128078,
		":thumbsdown_tone3:": 128078,
		":thumbsdown_tone4:": 128078,
		":thumbsdown_tone5:": 128078,
		":punch_tone1:": 128074,
		":punch_tone2:": 128074,
		":punch_tone3:": 128074,
		":punch_tone4:": 128074,
		":punch_tone5:": 128074,
		":fist_tone1:": 9994,
		":fist_tone2:": 9994,
		":fist_tone3:": 9994,
		":fist_tone4:": 9994,
		":fist_tone5:": 9994,
		":v_tone1:": 9996,
		":v_tone2:": 9996,
		":v_tone3:": 9996,
		":v_tone4:": 9996,
		":v_tone5:": 9996,
		":ok_hand_tone1:": 128076,
		":ok_hand_tone2:": 128076,
		":ok_hand_tone3:": 128076,
		":ok_hand_tone4:": 128076,
		":ok_hand_tone5:": 128076,
		":raised_hand_tone1:": 9995,
		":raised_hand_tone2:": 9995,
		":raised_hand_tone3:": 9995,
		":raised_hand_tone4:": 9995,
		":raised_hand_tone5:": 9995,
		":open_hands_tone1:": 128080,
		":open_hands_tone2:": 128080,
		":open_hands_tone3:": 128080,
		":open_hands_tone4:": 128080,
		":open_hands_tone5:": 128080,
		":muscle_tone1:": 128170,
		":muscle_tone2:": 128170,
		":muscle_tone3:": 128170,
		":muscle_tone4:": 128170,
		":muscle_tone5:": 128170,
		":pray_tone1:": 128591,
		":pray_tone2:": 128591,
		":pray_tone3:": 128591,
		":pray_tone4:": 128591,
		":pray_tone5:": 128591,
		":point_up_tone1:": 9757,
		":point_up_tone2:": 9757,
		":point_up_tone3:": 9757,
		":point_up_tone4:": 9757,
		":point_up_tone5:": 9757,
		":point_up_2_tone1:": 128070,
		":point_up_2_tone2:": 128070,
		":point_up_2_tone3:": 128070,
		":point_up_2_tone4:": 128070,
		":point_up_2_tone5:": 128070,
		":point_down_tone1:": 128071,
		":point_down_tone2:": 128071,
		":point_down_tone3:": 128071,
		":point_down_tone4:": 128071,
		":point_down_tone5:": 128071,
		":point_left_tone1:": 128072,
		":point_left_tone2:": 128072,
		":point_left_tone3:": 128072,
		":point_left_tone4:": 128072,
		":point_left_tone5:": 128072,
		":point_right_tone1:": 128073,
		":point_right_tone2:": 128073,
		":point_right_tone3:": 128073,
		":point_right_tone4:": 128073,
		":point_right_tone5:": 128073,
		":middle_finger_tone1:": 128405,
		":middle_finger_tone2:": 128405,
		":middle_finger_tone3:": 128405,
		":middle_finger_tone4:": 128405,
		":middle_finger_tone5:": 128405,
		":hand_splayed_tone1:": 128400,
		":hand_splayed_tone2:": 128400,
		":hand_splayed_tone3:": 128400,
		":hand_splayed_tone4:": 128400,
		":hand_splayed_tone5:": 128400,
		":metal_tone1:": 129304,
		":metal_tone2:": 129304,
		":metal_tone3:": 129304,
		":metal_tone4:": 129304,
		":metal_tone5:": 129304,
		":vulcan_tone1:": 128406,
		":vulcan_tone2:": 128406,
		":vulcan_tone3:": 128406,
		":vulcan_tone4:": 128406,
		":vulcan_tone5:": 128406,
		":writing_hand_tone1:": 9997,
		":writing_hand_tone2:": 9997,
		":writing_hand_tone3:": 9997,
		":writing_hand_tone4:": 9997,
		":writing_hand_tone5:": 9997,
		":nail_care_tone1:": 128133,
		":nail_care_tone2:": 128133,
		":nail_care_tone3:": 128133,
		":nail_care_tone4:": 128133,
		":nail_care_tone5:": 128133,
		":ear_tone1:": 128066,
		":ear_tone2:": 128066,
		":ear_tone3:": 128066,
		":ear_tone4:": 128066,
		":ear_tone5:": 128066,
		":nose_tone1:": 128067,
		":nose_tone2:": 128067,
		":nose_tone3:": 128067,
		":nose_tone4:": 128067,
		":nose_tone5:": 128067,
		":baby_tone1:": 128118,
		":baby_tone2:": 128118,
		":baby_tone3:": 128118,
		":baby_tone4:": 128118,
		":baby_tone5:": 128118,
		":boy_tone1:": 128102,
		":boy_tone2:": 128102,
		":boy_tone3:": 128102,
		":boy_tone4:": 128102,
		":boy_tone5:": 128102,
		":girl_tone1:": 128103,
		":girl_tone2:": 128103,
		":girl_tone3:": 128103,
		":girl_tone4:": 128103,
		":girl_tone5:": 128103,
		":man_tone1:": 128104,
		":man_tone2:": 128104,
		":man_tone3:": 128104,
		":man_tone4:": 128104,
		":man_tone5:": 128104,
		":woman_tone1:": 128105,
		":woman_tone2:": 128105,
		":woman_tone3:": 128105,
		":woman_tone4:": 128105,
		":woman_tone5:": 128105,
		":person_with_blond_hair_tone1:": 128113,
		":person_with_blond_hair_tone2:": 128113,
		":person_with_blond_hair_tone3:": 128113,
		":person_with_blond_hair_tone4:": 128113,
		":person_with_blond_hair_tone5:": 128113,
		":older_man_tone1:": 128116,
		":older_man_tone2:": 128116,
		":older_man_tone3:": 128116,
		":older_man_tone4:": 128116,
		":older_man_tone5:": 128116,
		":older_woman_tone1:": 128117,
		":older_woman_tone2:": 128117,
		":older_woman_tone3:": 128117,
		":older_woman_tone4:": 128117,
		":older_woman_tone5:": 128117,
		":man_with_gua_pi_mao_tone1:": 128114,
		":man_with_gua_pi_mao_tone2:": 128114,
		":man_with_gua_pi_mao_tone3:": 128114,
		":man_with_gua_pi_mao_tone4:": 128114,
		":man_with_gua_pi_mao_tone5:": 128114,
		":man_with_turban_tone1:": 128115,
		":man_with_turban_tone2:": 128115,
		":man_with_turban_tone3:": 128115,
		":man_with_turban_tone4:": 128115,
		":man_with_turban_tone5:": 128115,
		":cop_tone1:": 128110,
		":cop_tone2:": 128110,
		":cop_tone3:": 128110,
		":cop_tone4:": 128110,
		":cop_tone5:": 128110,
		":construction_worker_tone1:": 128119,
		":construction_worker_tone2:": 128119,
		":construction_worker_tone3:": 128119,
		":construction_worker_tone4:": 128119,
		":construction_worker_tone5:": 128119,
		":guardsman_tone1:": 128130,
		":guardsman_tone2:": 128130,
		":guardsman_tone3:": 128130,
		":guardsman_tone4:": 128130,
		":guardsman_tone5:": 128130,
		":santa_tone1:": 127877,
		":santa_tone2:": 127877,
		":santa_tone3:": 127877,
		":santa_tone4:": 127877,
		":santa_tone5:": 127877,
		":angel_tone1:": 128124,
		":angel_tone2:": 128124,
		":angel_tone3:": 128124,
		":angel_tone4:": 128124,
		":angel_tone5:": 128124,
		":princess_tone1:": 128120,
		":princess_tone2:": 128120,
		":princess_tone3:": 128120,
		":princess_tone4:": 128120,
		":princess_tone5:": 128120,
		":bride_with_veil_tone1:": 128112,
		":bride_with_veil_tone2:": 128112,
		":bride_with_veil_tone3:": 128112,
		":bride_with_veil_tone4:": 128112,
		":bride_with_veil_tone5:": 128112,
		":walking_tone1:": 128694,
		":walking_tone2:": 128694,
		":walking_tone3:": 128694,
		":walking_tone4:": 128694,
		":walking_tone5:": 128694,
		":runner_tone1:": 127939,
		":runner_tone2:": 127939,
		":runner_tone3:": 127939,
		":runner_tone4:": 127939,
		":runner_tone5:": 127939,
		":dancer_tone1:": 128131,
		":dancer_tone2:": 128131,
		":dancer_tone3:": 128131,
		":dancer_tone4:": 128131,
		":dancer_tone5:": 128131,
		":bow_tone1:": 128583,
		":bow_tone2:": 128583,
		":bow_tone3:": 128583,
		":bow_tone4:": 128583,
		":bow_tone5:": 128583,
		":information_desk_person_tone1:": 128129,
		":information_desk_person_tone2:": 128129,
		":information_desk_person_tone3:": 128129,
		":information_desk_person_tone4:": 128129,
		":information_desk_person_tone5:": 128129,
		":no_good_tone1:": 128581,
		":no_good_tone2:": 128581,
		":no_good_tone3:": 128581,
		":no_good_tone4:": 128581,
		":no_good_tone5:": 128581,
		":ok_woman_tone1:": 128582,
		":ok_woman_tone2:": 128582,
		":ok_woman_tone3:": 128582,
		":ok_woman_tone4:": 128582,
		":ok_woman_tone5:": 128582,
		":raising_hand_tone1:": 128587,
		":raising_hand_tone2:": 128587,
		":raising_hand_tone3:": 128587,
		":raising_hand_tone4:": 128587,
		":raising_hand_tone5:": 128587,
		":person_with_pouting_face_tone1:": 128590,
		":person_with_pouting_face_tone2:": 128590,
		":person_with_pouting_face_tone3:": 128590,
		":person_with_pouting_face_tone4:": 128590,
		":person_with_pouting_face_tone5:": 128590,
		":person_frowning_tone1:": 128589,
		":person_frowning_tone2:": 128589,
		":person_frowning_tone3:": 128589,
		":person_frowning_tone4:": 128589,
		":person_frowning_tone5:": 128589,
		":haircut_tone1:": 128135,
		":haircut_tone2:": 128135,
		":haircut_tone3:": 128135,
		":haircut_tone4:": 128135,
		":haircut_tone5:": 128135,
		":massage_tone1:": 128134,
		":massage_tone2:": 128134,
		":massage_tone3:": 128134,
		":massage_tone4:": 128134,
		":massage_tone5:": 128134,
		":rowboat_tone1:": 128675,
		":rowboat_tone2:": 128675,
		":rowboat_tone3:": 128675,
		":rowboat_tone4:": 128675,
		":rowboat_tone5:": 128675,
		":swimmer_tone1:": 127946,
		":swimmer_tone2:": 127946,
		":swimmer_tone3:": 127946,
		":swimmer_tone4:": 127946,
		":swimmer_tone5:": 127946,
		":surfer_tone1:": 127940,
		":surfer_tone2:": 127940,
		":surfer_tone3:": 127940,
		":surfer_tone4:": 127940,
		":surfer_tone5:": 127940,
		":bath_tone1:": 128704,
		":bath_tone2:": 128704,
		":bath_tone3:": 128704,
		":bath_tone4:": 128704,
		":bath_tone5:": 128704,
		":basketball_player_tone1:": 9977,
		":basketball_player_tone2:": 9977,
		":basketball_player_tone3:": 9977,
		":basketball_player_tone4:": 9977,
		":basketball_player_tone5:": 9977,
		":lifter_tone1:": 127947,
		":lifter_tone2:": 127947,
		":lifter_tone3:": 127947,
		":lifter_tone4:": 127947,
		":lifter_tone5:": 127947,
		":bicyclist_tone1:": 128692,
		":bicyclist_tone2:": 128692,
		":bicyclist_tone3:": 128692,
		":bicyclist_tone4:": 128692,
		":bicyclist_tone5:": 128692,
		":mountain_bicyclist_tone1:": 128693,
		":mountain_bicyclist_tone2:": 128693,
		":mountain_bicyclist_tone3:": 128693,
		":mountain_bicyclist_tone4:": 128693,
		":mountain_bicyclist_tone5:": 128693,
		":horse_racing_tone1:": 127943,
		":horse_racing_tone2:": 127943,
		":horse_racing_tone3:": 127943,
		":horse_racing_tone4:": 127943,
		":horse_racing_tone5:": 127943,
		":spy_tone1:": 128373,
		":spy_tone2:": 128373,
		":spy_tone3:": 128373,
		":spy_tone4:": 128373,
		":spy_tone5:": 128373
	},
	"categories": [
		{
			"id": "people",
			"name": "Smilies & People",
			"emoji": [
				":grinning:",
				":grimacing:",
				":grin:",
				":joy:",
				":smiley:",
				":smile:",
				":sweat_smile:",
				":laughing:",
				":innocent:",
				":wink:",
				":blush:",
				":slight_smile:",
				":upside_down:",
				":relaxed:",
				":yum:",
				":relieved:",
				":heart_eyes:",
				":kissing_heart:",
				":kissing:",
				":kissing_smiling_eyes:",
				":kissing_closed_eyes:",
				":stuck_out_tongue_winking_eye:",
				":stuck_out_tongue_closed_eyes:",
				":stuck_out_tongue:",
				":money_mouth:",
				":nerd:",
				":sunglasses:",
				":hugging:",
				":smirk:",
				":no_mouth:",
				":neutral_face:",
				":expressionless:",
				":unamused:",
				":rolling_eyes:",
				":thinking:",
				":flushed:",
				":disappointed:",
				":worried:",
				":angry:",
				":rage:",
				":pensive:",
				":confused:",
				":slight_frown:",
				":frowning2:",
				":persevere:",
				":confounded:",
				":tired_face:",
				":weary:",
				":triumph:",
				":open_mouth:",
				":scream:",
				":fearful:",
				":cold_sweat:",
				":hushed:",
				":frowning:",
				":anguished:",
				":cry:",
				":disappointed_relieved:",
				":sleepy:",
				":sweat:",
				":sob:",
				":dizzy_face:",
				":astonished:",
				":zipper_mouth:",
				":mask:",
				":thermometer_face:",
				":head_bandage:",
				":sleeping:",
				":zzz:",
				":poop:",
				":smiling_imp:",
				":imp:",
				":japanese_ogre:",
				":japanese_goblin:",
				":skull:",
				":ghost:",
				":alien:",
				":robot:",
				":smiley_cat:",
				":smile_cat:",
				":joy_cat:",
				":heart_eyes_cat:",
				":smirk_cat:",
				":kissing_cat:",
				":scream_cat:",
				":crying_cat_face:",
				":pouting_cat:",
				":raised_hands:",
				":clap:",
				":wave:",
				":thumbsup:",
				":thumbsdown:",
				":punch:",
				":fist:",
				":v:",
				":ok_hand:",
				":raised_hand:",
				":open_hands:",
				":muscle:",
				":pray:",
				":point_up:",
				":point_up_2:",
				":point_down:",
				":point_left:",
				":point_right:",
				":middle_finger:",
				":hand_splayed:",
				":metal:",
				":vulcan:",
				":writing_hand:",
				":nail_care:",
				":lips:",
				":tongue:",
				":ear:",
				":nose:",
				":eye:",
				":eyes:",
				":bust_in_silhouette:",
				":busts_in_silhouette:",
				":speaking_head:",
				":baby:",
				":boy:",
				":girl:",
				":man:",
				":woman:",
				":person_with_blond_hair:",
				":older_man:",
				":older_woman:",
				":man_with_gua_pi_mao:",
				":man_with_turban:",
				":cop:",
				":construction_worker:",
				":guardsman:",
				":spy:",
				":santa:",
				":angel:",
				":princess:",
				":bride_with_veil:",
				":walking:",
				":runner:",
				":dancer:",
				":dancers:",
				":couple:",
				":two_men_holding_hands:",
				":two_women_holding_hands:",
				":bow:",
				":information_desk_person:",
				":no_good:",
				":ok_woman:",
				":raising_hand:",
				":person_with_pouting_face:",
				":person_frowning:",
				":haircut:",
				":massage:",
				":couple_with_heart:",
				":couple_ww:",
				":couple_mm:",
				":couplekiss:",
				":kiss_ww:",
				":kiss_mm:",
				":family:",
				":family_mwg:",
				":family_mwgb:",
				":family_mwbb:",
				":family_mwgg:",
				":family_wwb:",
				":family_wwg:",
				":family_wwgb:",
				":family_wwbb:",
				":family_wwgg:",
				":family_mmb:",
				":family_mmg:",
				":family_mmgb:",
				":family_mmbb:",
				":family_mmgg:",
				":womans_clothes:",
				":shirt:",
				":jeans:",
				":necktie:",
				":dress:",
				":bikini:",
				":kimono:",
				":lipstick:",
				":kiss:",
				":footprints:",
				":high_heel:",
				":sandal:",
				":boot:",
				":mans_shoe:",
				":athletic_shoe:",
				":womans_hat:",
				":tophat:",
				":helmet_with_cross:",
				":mortar_board:",
				":crown:",
				":school_satchel:",
				":pouch:",
				":purse:",
				":handbag:",
				":briefcase:",
				":eyeglasses:",
				":dark_sunglasses:",
				":ring:",
				":closed_umbrella:",
				":raised_hands_tone1:",
				":raised_hands_tone2:",
				":raised_hands_tone3:",
				":raised_hands_tone4:",
				":raised_hands_tone5:",
				":clap_tone1:",
				":clap_tone2:",
				":clap_tone3:",
				":clap_tone4:",
				":clap_tone5:",
				":wave_tone1:",
				":wave_tone2:",
				":wave_tone3:",
				":wave_tone4:",
				":wave_tone5:",
				":thumbsup_tone1:",
				":thumbsup_tone2:",
				":thumbsup_tone3:",
				":thumbsup_tone4:",
				":thumbsup_tone5:",
				":thumbsdown_tone1:",
				":thumbsdown_tone2:",
				":thumbsdown_tone3:",
				":thumbsdown_tone4:",
				":thumbsdown_tone5:",
				":punch_tone1:",
				":punch_tone2:",
				":punch_tone3:",
				":punch_tone4:",
				":punch_tone5:",
				":fist_tone1:",
				":fist_tone2:",
				":fist_tone3:",
				":fist_tone4:",
				":fist_tone5:",
				":v_tone1:",
				":v_tone2:",
				":v_tone3:",
				":v_tone4:",
				":v_tone5:",
				":ok_hand_tone1:",
				":ok_hand_tone2:",
				":ok_hand_tone3:",
				":ok_hand_tone4:",
				":ok_hand_tone5:",
				":raised_hand_tone1:",
				":raised_hand_tone2:",
				":raised_hand_tone3:",
				":raised_hand_tone4:",
				":raised_hand_tone5:",
				":open_hands_tone1:",
				":open_hands_tone2:",
				":open_hands_tone3:",
				":open_hands_tone4:",
				":open_hands_tone5:",
				":muscle_tone1:",
				":muscle_tone2:",
				":muscle_tone3:",
				":muscle_tone4:",
				":muscle_tone5:",
				":pray_tone1:",
				":pray_tone2:",
				":pray_tone3:",
				":pray_tone4:",
				":pray_tone5:",
				":point_up_tone1:",
				":point_up_tone2:",
				":point_up_tone3:",
				":point_up_tone4:",
				":point_up_tone5:",
				":point_up_2_tone1:",
				":point_up_2_tone2:",
				":point_up_2_tone3:",
				":point_up_2_tone4:",
				":point_up_2_tone5:",
				":point_down_tone1:",
				":point_down_tone2:",
				":point_down_tone3:",
				":point_down_tone4:",
				":point_down_tone5:",
				":point_left_tone1:",
				":point_left_tone2:",
				":point_left_tone3:",
				":point_left_tone4:",
				":point_left_tone5:",
				":point_right_tone1:",
				":point_right_tone2:",
				":point_right_tone3:",
				":point_right_tone4:",
				":point_right_tone5:",
				":middle_finger_tone1:",
				":middle_finger_tone2:",
				":middle_finger_tone3:",
				":middle_finger_tone4:",
				":middle_finger_tone5:",
				":hand_splayed_tone1:",
				":hand_splayed_tone2:",
				":hand_splayed_tone3:",
				":hand_splayed_tone4:",
				":hand_splayed_tone5:",
				":metal_tone1:",
				":metal_tone2:",
				":metal_tone3:",
				":metal_tone4:",
				":metal_tone5:",
				":vulcan_tone1:",
				":vulcan_tone2:",
				":vulcan_tone3:",
				":vulcan_tone4:",
				":vulcan_tone5:",
				":writing_hand_tone1:",
				":writing_hand_tone2:",
				":writing_hand_tone3:",
				":writing_hand_tone4:",
				":writing_hand_tone5:",
				":nail_care_tone1:",
				":nail_care_tone2:",
				":nail_care_tone3:",
				":nail_care_tone4:",
				":nail_care_tone5:",
				":ear_tone1:",
				":ear_tone2:",
				":ear_tone3:",
				":ear_tone4:",
				":ear_tone5:",
				":nose_tone1:",
				":nose_tone2:",
				":nose_tone3:",
				":nose_tone4:",
				":nose_tone5:",
				":baby_tone1:",
				":baby_tone2:",
				":baby_tone3:",
				":baby_tone4:",
				":baby_tone5:",
				":boy_tone1:",
				":boy_tone2:",
				":boy_tone3:",
				":boy_tone4:",
				":boy_tone5:",
				":girl_tone1:",
				":girl_tone2:",
				":girl_tone3:",
				":girl_tone4:",
				":girl_tone5:",
				":man_tone1:",
				":man_tone2:",
				":man_tone3:",
				":man_tone4:",
				":man_tone5:",
				":woman_tone1:",
				":woman_tone2:",
				":woman_tone3:",
				":woman_tone4:",
				":woman_tone5:",
				":person_with_blond_hair_tone1:",
				":person_with_blond_hair_tone2:",
				":person_with_blond_hair_tone3:",
				":person_with_blond_hair_tone4:",
				":person_with_blond_hair_tone5:",
				":older_man_tone1:",
				":older_man_tone2:",
				":older_man_tone3:",
				":older_man_tone4:",
				":older_man_tone5:",
				":older_woman_tone1:",
				":older_woman_tone2:",
				":older_woman_tone3:",
				":older_woman_tone4:",
				":older_woman_tone5:",
				":man_with_gua_pi_mao_tone1:",
				":man_with_gua_pi_mao_tone2:",
				":man_with_gua_pi_mao_tone3:",
				":man_with_gua_pi_mao_tone4:",
				":man_with_gua_pi_mao_tone5:",
				":man_with_turban_tone1:",
				":man_with_turban_tone2:",
				":man_with_turban_tone3:",
				":man_with_turban_tone4:",
				":man_with_turban_tone5:",
				":cop_tone1:",
				":cop_tone2:",
				":cop_tone3:",
				":cop_tone4:",
				":cop_tone5:",
				":construction_worker_tone1:",
				":construction_worker_tone2:",
				":construction_worker_tone3:",
				":construction_worker_tone4:",
				":construction_worker_tone5:",
				":guardsman_tone1:",
				":guardsman_tone2:",
				":guardsman_tone3:",
				":guardsman_tone4:",
				":guardsman_tone5:",
				":santa_tone1:",
				":santa_tone2:",
				":santa_tone3:",
				":santa_tone4:",
				":santa_tone5:",
				":angel_tone1:",
				":angel_tone2:",
				":angel_tone3:",
				":angel_tone4:",
				":angel_tone5:",
				":princess_tone1:",
				":princess_tone2:",
				":princess_tone3:",
				":princess_tone4:",
				":princess_tone5:",
				":bride_with_veil_tone1:",
				":bride_with_veil_tone2:",
				":bride_with_veil_tone3:",
				":bride_with_veil_tone4:",
				":bride_with_veil_tone5:",
				":walking_tone1:",
				":walking_tone2:",
				":walking_tone3:",
				":walking_tone4:",
				":walking_tone5:",
				":runner_tone1:",
				":runner_tone2:",
				":runner_tone3:",
				":runner_tone4:",
				":runner_tone5:",
				":dancer_tone1:",
				":dancer_tone2:",
				":dancer_tone3:",
				":dancer_tone4:",
				":dancer_tone5:",
				":bow_tone1:",
				":bow_tone2:",
				":bow_tone3:",
				":bow_tone4:",
				":bow_tone5:",
				":information_desk_person_tone1:",
				":information_desk_person_tone2:",
				":information_desk_person_tone3:",
				":information_desk_person_tone4:",
				":information_desk_person_tone5:",
				":no_good_tone1:",
				":no_good_tone2:",
				":no_good_tone3:",
				":no_good_tone4:",
				":no_good_tone5:",
				":ok_woman_tone1:",
				":ok_woman_tone2:",
				":ok_woman_tone3:",
				":ok_woman_tone4:",
				":ok_woman_tone5:",
				":raising_hand_tone1:",
				":raising_hand_tone2:",
				":raising_hand_tone3:",
				":raising_hand_tone4:",
				":raising_hand_tone5:",
				":person_with_pouting_face_tone1:",
				":person_with_pouting_face_tone2:",
				":person_with_pouting_face_tone3:",
				":person_with_pouting_face_tone4:",
				":person_with_pouting_face_tone5:",
				":person_frowning_tone1:",
				":person_frowning_tone2:",
				":person_frowning_tone3:",
				":person_frowning_tone4:",
				":person_frowning_tone5:",
				":haircut_tone1:",
				":haircut_tone2:",
				":haircut_tone3:",
				":haircut_tone4:",
				":haircut_tone5:",
				":massage_tone1:",
				":massage_tone2:",
				":massage_tone3:",
				":massage_tone4:",
				":massage_tone5:",
				":spy_tone1:",
				":spy_tone2:",
				":spy_tone3:",
				":spy_tone4:",
				":spy_tone5:"
			]
		},
		{
			"id": "nature",
			"name": "Animals & Nature",
			"emoji": [
				":dog:",
				":cat:",
				":mouse:",
				":hamster:",
				":rabbit:",
				":bear:",
				":panda_face:",
				":koala:",
				":tiger:",
				":lion_face:",
				":cow:",
				":pig:",
				":pig_nose:",
				":frog:",
				":octopus:",
				":monkey_face:",
				":see_no_evil:",
				":hear_no_evil:",
				":speak_no_evil:",
				":monkey:",
				":chicken:",
				":penguin:",
				":bird:",
				":baby_chick:",
				":hatching_chick:",
				":hatched_chick:",
				":wolf:",
				":boar:",
				":horse:",
				":unicorn:",
				":bee:",
				":bug:",
				":snail:",
				":beetle:",
				":ant:",
				":spider:",
				":scorpion:",
				":crab:",
				":snake:",
				":turtle:",
				":tropical_fish:",
				":fish:",
				":blowfish:",
				":dolphin:",
				":whale:",
				":whale2:",
				":crocodile:",
				":leopard:",
				":tiger2:",
				":water_buffalo:",
				":ox:",
				":cow2:",
				":dromedary_camel:",
				":camel:",
				":elephant:",
				":goat:",
				":ram:",
				":sheep:",
				":racehorse:",
				":pig2:",
				":rat:",
				":mouse2:",
				":rooster:",
				":turkey:",
				":dove:",
				":dog2:",
				":poodle:",
				":cat2:",
				":rabbit2:",
				":chipmunk:",
				":feet:",
				":dragon:",
				":dragon_face:",
				":cactus:",
				":christmas_tree:",
				":evergreen_tree:",
				":deciduous_tree:",
				":palm_tree:",
				":seedling:",
				":herb:",
				":shamrock:",
				":four_leaf_clover:",
				":bamboo:",
				":tanabata_tree:",
				":leaves:",
				":fallen_leaf:",
				":maple_leaf:",
				":ear_of_rice:",
				":hibiscus:",
				":sunflower:",
				":rose:",
				":tulip:",
				":blossom:",
				":cherry_blossom:",
				":bouquet:",
				":mushroom:",
				":chestnut:",
				":jack_o_lantern:",
				":shell:",
				":spider_web:",
				":earth_americas:",
				":earth_africa:",
				":earth_asia:",
				":full_moon:",
				":waning_gibbous_moon:",
				":last_quarter_moon:",
				":waning_crescent_moon:",
				":new_moon:",
				":waxing_crescent_moon:",
				":first_quarter_moon:",
				":waxing_gibbous_moon:",
				":new_moon_with_face:",
				":full_moon_with_face:",
				":first_quarter_moon_with_face:",
				":last_quarter_moon_with_face:",
				":sun_with_face:",
				":crescent_moon:",
				":star:",
				":star2:",
				":dizzy:",
				":sparkles:",
				":comet:",
				":sunny:",
				":white_sun_small_cloud:",
				":partly_sunny:",
				":white_sun_cloud:",
				":white_sun_rain_cloud:",
				":cloud:",
				":cloud_rain:",
				":thunder_cloud_rain:",
				":cloud_lightning:",
				":zap:",
				":fire:",
				":boom:",
				":snowflake:",
				":cloud_snow:",
				":snowman2:",
				":snowman:",
				":wind_blowing_face:",
				":dash:",
				":cloud_tornado:",
				":fog:",
				":umbrella2:",
				":umbrella:",
				":droplet:",
				":sweat_drops:",
				":ocean:"
			]
		},
		{
			"id": "food",
			"name": "Food & Drink",
			"emoji": [
				":green_apple:",
				":apple:",
				":pear:",
				":tangerine:",
				":lemon:",
				":banana:",
				":watermelon:",
				":grapes:",
				":strawberry:",
				":melon:",
				":cherries:",
				":peach:",
				":pineapple:",
				":tomato:",
				":eggplant:",
				":hot_pepper:",
				":corn:",
				":sweet_potato:",
				":honey_pot:",
				":bread:",
				":cheese:",
				":poultry_leg:",
				":meat_on_bone:",
				":fried_shrimp:",
				":egg:",
				":hamburger:",
				":fries:",
				":hotdog:",
				":pizza:",
				":spaghetti:",
				":taco:",
				":burrito:",
				":ramen:",
				":stew:",
				":fish_cake:",
				":sushi:",
				":bento:",
				":curry:",
				":rice_ball:",
				":rice:",
				":rice_cracker:",
				":oden:",
				":dango:",
				":shaved_ice:",
				":ice_cream:",
				":icecream:",
				":cake:",
				":birthday:",
				":custard:",
				":candy:",
				":lollipop:",
				":chocolate_bar:",
				":popcorn:",
				":doughnut:",
				":cookie:",
				":beer:",
				":beers:",
				":wine_glass:",
				":cocktail:",
				":tropical_drink:",
				":champagne:",
				":sake:",
				":tea:",
				":coffee:",
				":baby_bottle:",
				":fork_and_knife:",
				":fork_knife_plate:"
			]
		},
		{
			"id": "activity",
			"name": "Activity",
			"emoji": [
				":soccer:",
				":basketball:",
				":football:",
				":baseball:",
				":tennis:",
				":volleyball:",
				":rugby_football:",
				":8ball:",
				":golf:",
				":golfer:",
				":ping_pong:",
				":badminton:",
				":hockey:",
				":field_hockey:",
				":cricket:",
				":ski:",
				":skier:",
				":snowboarder:",
				":ice_skate:",
				":bow_and_arrow:",
				":fishing_pole_and_fish:",
				":rowboat:",
				":swimmer:",
				":surfer:",
				":bath:",
				":basketball_player:",
				":lifter:",
				":bicyclist:",
				":mountain_bicyclist:",
				":horse_racing:",
				":levitate:",
				":trophy:",
				":running_shirt_with_sash:",
				":medal:",
				":military_medal:",
				":reminder_ribbon:",
				":rosette:",
				":ticket:",
				":tickets:",
				":performing_arts:",
				":art:",
				":circus_tent:",
				":microphone:",
				":headphones:",
				":musical_score:",
				":musical_keyboard:",
				":saxophone:",
				":trumpet:",
				":guitar:",
				":violin:",
				":clapper:",
				":video_game:",
				":space_invader:",
				":dart:",
				":game_die:",
				":slot_machine:",
				":bowling:",
				":rowboat_tone1:",
				":rowboat_tone2:",
				":rowboat_tone3:",
				":rowboat_tone4:",
				":rowboat_tone5:",
				":swimmer_tone1:",
				":swimmer_tone2:",
				":swimmer_tone3:",
				":swimmer_tone4:",
				":swimmer_tone5:",
				":surfer_tone1:",
				":surfer_tone2:",
				":surfer_tone3:",
				":surfer_tone4:",
				":surfer_tone5:",
				":bath_tone1:",
				":bath_tone2:",
				":bath_tone3:",
				":bath_tone4:",
				":bath_tone5:",
				":basketball_player_tone1:",
				":basketball_player_tone2:",
				":basketball_player_tone3:",
				":basketball_player_tone4:",
				":basketball_player_tone5:",
				":lifter_tone1:",
				":lifter_tone2:",
				":lifter_tone3:",
				":lifter_tone4:",
				":lifter_tone5:",
				":bicyclist_tone1:",
				":bicyclist_tone2:",
				":bicyclist_tone3:",
				":bicyclist_tone4:",
				":bicyclist_tone5:",
				":mountain_bicyclist_tone1:",
				":mountain_bicyclist_tone2:",
				":mountain_bicyclist_tone3:",
				":mountain_bicyclist_tone4:",
				":mountain_bicyclist_tone5:",
				":horse_racing_tone1:",
				":horse_racing_tone2:",
				":horse_racing_tone3:",
				":horse_racing_tone4:",
				":horse_racing_tone5:"
			]
		},
		{
			"id": "travel",
			"name": "Travel & Places",
			"emoji": [
				":red_car:",
				":taxi:",
				":blue_car:",
				":bus:",
				":trolleybus:",
				":race_car:",
				":police_car:",
				":ambulance:",
				":fire_engine:",
				":minibus:",
				":truck:",
				":articulated_lorry:",
				":tractor:",
				":motorcycle:",
				":bike:",
				":rotating_light:",
				":oncoming_police_car:",
				":oncoming_bus:",
				":oncoming_automobile:",
				":oncoming_taxi:",
				":aerial_tramway:",
				":mountain_cableway:",
				":suspension_railway:",
				":railway_car:",
				":train:",
				":monorail:",
				":bullettrain_side:",
				":bullettrain_front:",
				":light_rail:",
				":mountain_railway:",
				":steam_locomotive:",
				":train2:",
				":metro:",
				":tram:",
				":station:",
				":helicopter:",
				":airplane_small:",
				":airplane:",
				":airplane_departure:",
				":airplane_arriving:",
				":sailboat:",
				":motorboat:",
				":speedboat:",
				":ferry:",
				":cruise_ship:",
				":rocket:",
				":satellite_orbital:",
				":seat:",
				":anchor:",
				":construction:",
				":fuelpump:",
				":busstop:",
				":vertical_traffic_light:",
				":traffic_light:",
				":checkered_flag:",
				":ship:",
				":ferris_wheel:",
				":roller_coaster:",
				":carousel_horse:",
				":construction_site:",
				":foggy:",
				":tokyo_tower:",
				":factory:",
				":fountain:",
				":rice_scene:",
				":mountain:",
				":mountain_snow:",
				":mount_fuji:",
				":volcano:",
				":japan:",
				":camping:",
				":tent:",
				":park:",
				":motorway:",
				":railway_track:",
				":sunrise:",
				":sunrise_over_mountains:",
				":desert:",
				":beach:",
				":island:",
				":city_sunset:",
				":city_dusk:",
				":cityscape:",
				":night_with_stars:",
				":bridge_at_night:",
				":milky_way:",
				":stars:",
				":sparkler:",
				":fireworks:",
				":rainbow:",
				":homes:",
				":european_castle:",
				":japanese_castle:",
				":stadium:",
				":statue_of_liberty:",
				":house:",
				":house_with_garden:",
				":house_abandoned:",
				":office:",
				":department_store:",
				":post_office:",
				":european_post_office:",
				":hospital:",
				":bank:",
				":hotel:",
				":convenience_store:",
				":school:",
				":love_hotel:",
				":wedding:",
				":classical_building:",
				":church:",
				":mosque:",
				":synagogue:",
				":kaaba:",
				":shinto_shrine:"
			]
		},
		{
			"id": "objects",
			"name": "Objects",
			"emoji": [
				":watch:",
				":iphone:",
				":calling:",
				":computer:",
				":keyboard:",
				":desktop:",
				":printer:",
				":mouse_three_button:",
				":trackball:",
				":joystick:",
				":compression:",
				":minidisc:",
				":floppy_disk:",
				":cd:",
				":dvd:",
				":vhs:",
				":camera:",
				":camera_with_flash:",
				":video_camera:",
				":movie_camera:",
				":projector:",
				":film_frames:",
				":telephone_receiver:",
				":telephone:",
				":pager:",
				":fax:",
				":tv:",
				":radio:",
				":microphone2:",
				":level_slider:",
				":control_knobs:",
				":stopwatch:",
				":timer:",
				":alarm_clock:",
				":clock:",
				":hourglass_flowing_sand:",
				":hourglass:",
				":satellite:",
				":battery:",
				":electric_plug:",
				":bulb:",
				":flashlight:",
				":candle:",
				":wastebasket:",
				":oil:",
				":money_with_wings:",
				":dollar:",
				":yen:",
				":euro:",
				":pound:",
				":moneybag:",
				":credit_card:",
				":gem:",
				":scales:",
				":wrench:",
				":hammer:",
				":hammer_pick:",
				":tools:",
				":pick:",
				":nut_and_bolt:",
				":gear:",
				":chains:",
				":gun:",
				":bomb:",
				":knife:",
				":dagger:",
				":crossed_swords:",
				":shield:",
				":smoking:",
				":skull_crossbones:",
				":coffin:",
				":urn:",
				":amphora:",
				":crystal_ball:",
				":prayer_beads:",
				":barber:",
				":alembic:",
				":telescope:",
				":microscope:",
				":hole:",
				":pill:",
				":syringe:",
				":thermometer:",
				":label:",
				":bookmark:",
				":toilet:",
				":shower:",
				":bathtub:",
				":key:",
				":key2:",
				":couch:",
				":sleeping_accommodation:",
				":bed:",
				":door:",
				":bellhop:",
				":frame_photo:",
				":map:",
				":beach_umbrella:",
				":moyai:",
				":shopping_bags:",
				":balloon:",
				":flags:",
				":ribbon:",
				":gift:",
				":confetti_ball:",
				":tada:",
				":dolls:",
				":wind_chime:",
				":crossed_flags:",
				":izakaya_lantern:",
				":envelope:",
				":envelope_with_arrow:",
				":incoming_envelope:",
				":e-mail:",
				":love_letter:",
				":postbox:",
				":mailbox_closed:",
				":mailbox:",
				":mailbox_with_mail:",
				":mailbox_with_no_mail:",
				":package:",
				":postal_horn:",
				":inbox_tray:",
				":outbox_tray:",
				":scroll:",
				":page_with_curl:",
				":bookmark_tabs:",
				":bar_chart:",
				":chart_with_upwards_trend:",
				":chart_with_downwards_trend:",
				":page_facing_up:",
				":date:",
				":calendar:",
				":calendar_spiral:",
				":card_index:",
				":card_box:",
				":ballot_box:",
				":file_cabinet:",
				":clipboard:",
				":notepad_spiral:",
				":file_folder:",
				":open_file_folder:",
				":dividers:",
				":newspaper2:",
				":newspaper:",
				":notebook:",
				":closed_book:",
				":green_book:",
				":blue_book:",
				":orange_book:",
				":notebook_with_decorative_cover:",
				":ledger:",
				":books:",
				":book:",
				":link:",
				":paperclip:",
				":paperclips:",
				":scissors:",
				":triangular_ruler:",
				":straight_ruler:",
				":pushpin:",
				":round_pushpin:",
				":triangular_flag_on_post:",
				":flag_white:",
				":flag_black:",
				":closed_lock_with_key:",
				":lock:",
				":unlock:",
				":lock_with_ink_pen:",
				":pen_ballpoint:",
				":pen_fountain:",
				":black_nib:",
				":pencil:",
				":pencil2:",
				":crayon:",
				":paintbrush:",
				":mag:",
				":mag_right:"
			]
		},
		{
			"id": "symbols",
			"name": "Symbols",
			"emoji": [
				":heart:",
				":yellow_heart:",
				":green_heart:",
				":blue_heart:",
				":purple_heart:",
				":broken_heart:",
				":heart_exclamation:",
				":two_hearts:",
				":revolving_hearts:",
				":heartbeat:",
				":heartpulse:",
				":sparkling_heart:",
				":cupid:",
				":gift_heart:",
				":heart_decoration:",
				":peace:",
				":cross:",
				":star_and_crescent:",
				":om_symbol:",
				":wheel_of_dharma:",
				":star_of_david:",
				":six_pointed_star:",
				":menorah:",
				":yin_yang:",
				":orthodox_cross:",
				":place_of_worship:",
				":ophiuchus:",
				":aries:",
				":taurus:",
				":gemini:",
				":cancer:",
				":leo:",
				":virgo:",
				":libra:",
				":scorpius:",
				":sagittarius:",
				":capricorn:",
				":aquarius:",
				":pisces:",
				":id:",
				":atom:",
				":u7a7a:",
				":u5272:",
				":radioactive:",
				":biohazard:",
				":mobile_phone_off:",
				":vibration_mode:",
				":u6709:",
				":u7121:",
				":u7533:",
				":u55b6:",
				":u6708:",
				":eight_pointed_black_star:",
				":vs:",
				":accept:",
				":white_flower:",
				":ideograph_advantage:",
				":secret:",
				":congratulations:",
				":u5408:",
				":u6e80:",
				":u7981:",
				":a:",
				":b:",
				":ab:",
				":cl:",
				":o2:",
				":sos:",
				":no_entry:",
				":name_badge:",
				":no_entry_sign:",
				":x:",
				":o:",
				":anger:",
				":hotsprings:",
				":no_pedestrians:",
				":do_not_litter:",
				":no_bicycles:",
				":non-potable_water:",
				":underage:",
				":no_mobile_phones:",
				":exclamation:",
				":grey_exclamation:",
				":question:",
				":grey_question:",
				":bangbang:",
				":interrobang:",
				":100:",
				":low_brightness:",
				":high_brightness:",
				":trident:",
				":fleur-de-lis:",
				":part_alternation_mark:",
				":warning:",
				":children_crossing:",
				":beginner:",
				":recycle:",
				":u6307:",
				":chart:",
				":sparkle:",
				":eight_spoked_asterisk:",
				":negative_squared_cross_mark:",
				":white_check_mark:",
				":diamond_shape_with_a_dot_inside:",
				":cyclone:",
				":loop:",
				":globe_with_meridians:",
				":m:",
				":atm:",
				":sa:",
				":passport_control:",
				":customs:",
				":baggage_claim:",
				":left_luggage:",
				":wheelchair:",
				":no_smoking:",
				":wc:",
				":parking:",
				":potable_water:",
				":mens:",
				":womens:",
				":baby_symbol:",
				":restroom:",
				":put_litter_in_its_place:",
				":cinema:",
				":signal_strength:",
				":koko:",
				":ng:",
				":ok:",
				":up:",
				":cool:",
				":new:",
				":free:",
				":zero:",
				":one:",
				":two:",
				":three:",
				":four:",
				":five:",
				":six:",
				":seven:",
				":eight:",
				":nine:",
				":ten:",
				":1234:",
				":arrow_forward:",
				":pause_button:",
				":play_pause:",
				":stop_button:",
				":record_button:",
				":track_next:",
				":track_previous:",
				":fast_forward:",
				":rewind:",
				":twisted_rightwards_arrows:",
				":repeat:",
				":repeat_one:",
				":arrow_backward:",
				":arrow_up_small:",
				":arrow_down_small:",
				":arrow_double_up:",
				":arrow_double_down:",
				":arrow_right:",
				":arrow_left:",
				":arrow_up:",
				":arrow_down:",
				":arrow_upper_right:",
				":arrow_lower_right:",
				":arrow_lower_left:",
				":arrow_upper_left:",
				":arrow_up_down:",
				":left_right_arrow:",
				":arrows_counterclockwise:",
				":arrow_right_hook:",
				":leftwards_arrow_with_hook:",
				":arrow_heading_up:",
				":arrow_heading_down:",
				":hash:",
				":asterisk:",
				":information_source:",
				":abc:",
				":abcd:",
				":capital_abcd:",
				":symbols:",
				":musical_note:",
				":notes:",
				":wavy_dash:",
				":curly_loop:",
				":heavy_check_mark:",
				":arrows_clockwise:",
				":heavy_plus_sign:",
				":heavy_minus_sign:",
				":heavy_division_sign:",
				":heavy_multiplication_x:",
				":heavy_dollar_sign:",
				":currency_exchange:",
				":copyright:",
				":registered:",
				":tm:",
				":end:",
				":back:",
				":on:",
				":top:",
				":soon:",
				":ballot_box_with_check:",
				":radio_button:",
				":white_circle:",
				":black_circle:",
				":red_circle:",
				":large_blue_circle:",
				":small_orange_diamond:",
				":small_blue_diamond:",
				":large_orange_diamond:",
				":large_blue_diamond:",
				":small_red_triangle:",
				":black_small_square:",
				":white_small_square:",
				":black_large_square:",
				":white_large_square:",
				":small_red_triangle_down:",
				":black_medium_square:",
				":white_medium_square:",
				":black_medium_small_square:",
				":white_medium_small_square:",
				":black_square_button:",
				":white_square_button:",
				":speaker:",
				":sound:",
				":loud_sound:",
				":mute:",
				":mega:",
				":loudspeaker:",
				":bell:",
				":no_bell:",
				":black_joker:",
				":mahjong:",
				":spades:",
				":clubs:",
				":hearts:",
				":diamonds:",
				":flower_playing_cards:",
				":thought_balloon:",
				":anger_right:",
				":speech_balloon:",
				":clock1:",
				":clock2:",
				":clock3:",
				":clock4:",
				":clock5:",
				":clock6:",
				":clock7:",
				":clock8:",
				":clock9:",
				":clock10:",
				":clock11:",
				":clock12:",
				":clock130:",
				":clock230:",
				":clock330:",
				":clock430:",
				":clock530:",
				":clock630:",
				":clock730:",
				":clock830:",
				":clock930:",
				":clock1030:",
				":clock1130:",
				":clock1230:",
				":eye_in_speech_bubble:"
			]
		},
		{
			"id": "flags",
			"name": "Flags",
			"emoji": [
				":flag_ac:",
				":flag_af:",
				":flag_al:",
				":flag_dz:",
				":flag_ad:",
				":flag_ao:",
				":flag_ai:",
				":flag_ag:",
				":flag_ar:",
				":flag_am:",
				":flag_aw:",
				":flag_au:",
				":flag_at:",
				":flag_az:",
				":flag_bs:",
				":flag_bh:",
				":flag_bd:",
				":flag_bb:",
				":flag_by:",
				":flag_be:",
				":flag_bz:",
				":flag_bj:",
				":flag_bm:",
				":flag_bt:",
				":flag_bo:",
				":flag_ba:",
				":flag_bw:",
				":flag_br:",
				":flag_bn:",
				":flag_bg:",
				":flag_bf:",
				":flag_bi:",
				":flag_cv:",
				":flag_kh:",
				":flag_cm:",
				":flag_ca:",
				":flag_ky:",
				":flag_cf:",
				":flag_td:",
				":flag_cl:",
				":flag_cn:",
				":flag_co:",
				":flag_km:",
				":flag_cg:",
				":flag_cd:",
				":flag_cr:",
				":flag_hr:",
				":flag_cu:",
				":flag_cy:",
				":flag_cz:",
				":flag_dk:",
				":flag_dj:",
				":flag_dm:",
				":flag_do:",
				":flag_ec:",
				":flag_eg:",
				":flag_sv:",
				":flag_gq:",
				":flag_er:",
				":flag_ee:",
				":flag_et:",
				":flag_fk:",
				":flag_fo:",
				":flag_fj:",
				":flag_fi:",
				":flag_fr:",
				":flag_pf:",
				":flag_ga:",
				":flag_gm:",
				":flag_ge:",
				":flag_de:",
				":flag_gh:",
				":flag_gi:",
				":flag_gr:",
				":flag_gl:",
				":flag_gd:",
				":flag_gu:",
				":flag_gt:",
				":flag_gn:",
				":flag_gw:",
				":flag_gy:",
				":flag_ht:",
				":flag_hn:",
				":flag_hk:",
				":flag_hu:",
				":flag_is:",
				":flag_in:",
				":flag_id:",
				":flag_ir:",
				":flag_iq:",
				":flag_ie:",
				":flag_il:",
				":flag_it:",
				":flag_ci:",
				":flag_jm:",
				":flag_jp:",
				":flag_je:",
				":flag_jo:",
				":flag_kz:",
				":flag_ke:",
				":flag_ki:",
				":flag_xk:",
				":flag_kw:",
				":flag_kg:",
				":flag_la:",
				":flag_lv:",
				":flag_lb:",
				":flag_ls:",
				":flag_lr:",
				":flag_ly:",
				":flag_li:",
				":flag_lt:",
				":flag_lu:",
				":flag_mo:",
				":flag_mk:",
				":flag_mg:",
				":flag_mw:",
				":flag_my:",
				":flag_mv:",
				":flag_ml:",
				":flag_mt:",
				":flag_mh:",
				":flag_mr:",
				":flag_mu:",
				":flag_mx:",
				":flag_fm:",
				":flag_md:",
				":flag_mc:",
				":flag_mn:",
				":flag_me:",
				":flag_ms:",
				":flag_ma:",
				":flag_mz:",
				":flag_mm:",
				":flag_na:",
				":flag_nr:",
				":flag_np:",
				":flag_nl:",
				":flag_nc:",
				":flag_nz:",
				":flag_ni:",
				":flag_ne:",
				":flag_ng:",
				":flag_nu:",
				":flag_kp:",
				":flag_no:",
				":flag_om:",
				":flag_pk:",
				":flag_pw:",
				":flag_ps:",
				":flag_pa:",
				":flag_pg:",
				":flag_py:",
				":flag_pe:",
				":flag_ph:",
				":flag_pl:",
				":flag_pt:",
				":flag_pr:",
				":flag_qa:",
				":flag_ro:",
				":flag_ru:",
				":flag_rw:",
				":flag_sh:",
				":flag_kn:",
				":flag_lc:",
				":flag_vc:",
				":flag_ws:",
				":flag_sm:",
				":flag_st:",
				":flag_sa:",
				":flag_sn:",
				":flag_rs:",
				":flag_sc:",
				":flag_sl:",
				":flag_sg:",
				":flag_sk:",
				":flag_si:",
				":flag_sb:",
				":flag_so:",
				":flag_za:",
				":flag_kr:",
				":flag_es:",
				":flag_lk:",
				":flag_sd:",
				":flag_sr:",
				":flag_sz:",
				":flag_se:",
				":flag_ch:",
				":flag_sy:",
				":flag_tw:",
				":flag_tj:",
				":flag_tz:",
				":flag_th:",
				":flag_tl:",
				":flag_tg:",
				":flag_to:",
				":flag_tt:",
				":flag_tn:",
				":flag_tr:",
				":flag_tm:",
				":flag_tv:",
				":flag_ug:",
				":flag_ua:",
				":flag_ae:",
				":flag_gb:",
				":flag_us:",
				":flag_vi:",
				":flag_uy:",
				":flag_uz:",
				":flag_vu:",
				":flag_va:",
				":flag_ve:",
				":flag_vn:",
				":flag_wf:",
				":flag_eh:",
				":flag_ye:",
				":flag_zm:",
				":flag_zw:",
				":flag_re:",
				":flag_ax:",
				":flag_ta:",
				":flag_io:",
				":flag_bq:",
				":flag_cx:",
				":flag_cc:",
				":flag_gg:",
				":flag_im:",
				":flag_yt:",
				":flag_nf:",
				":flag_pn:",
				":flag_bl:",
				":flag_pm:",
				":flag_gs:",
				":flag_tk:",
				":flag_bv:",
				":flag_hm:",
				":flag_sj:",
				":flag_um:",
				":flag_ic:",
				":flag_ea:",
				":flag_cp:",
				":flag_dg:",
				":flag_as:",
				":flag_aq:",
				":flag_vg:",
				":flag_ck:",
				":flag_cw:",
				":flag_eu:",
				":flag_gf:",
				":flag_tf:",
				":flag_gp:",
				":flag_mq:",
				":flag_mp:",
				":flag_sx:",
				":flag_ss:",
				":flag_tc:",
				":flag_mf:"
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./lib/emoji.json
// module id = 1628
// module chunks = 3